// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/PropertyPortals/index.css
// module id = 1883
// module chunks = 0